import React, { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AlertCircleIcon, Loader2Icon } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { TextField } from '../../components/ui/Field';
import { useAdminData } from '../../contexts/AdminDataContext';
import { company } from '../../data/site';
export function AdminLogin() {
  const {
    loggedIn,
    authLoading,
    login
  } = useAdminData();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [errorCode, setErrorCode] = useState('');
  const [loading, setLoading] = useState(false);
  if (loggedIn) return <Navigate to="/admin" replace data-id="element-228" data-mp="egd0r131jet0" />;
  return <div className="flex min-h-screen w-full items-center bg-canvas px-5 py-12" data-id="element-229" data-mp="1urpbc3f4oyx7">
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto w-full max-w-sm" data-id="element-230" data-mp="1ptnr3f5yutk5">
        <img src={company.logoWide} alt="LYKKEVÆRK" className="h-14 w-auto" data-id="element-231" data-mp="20opbbdbffoh4" />
        <h1 className="mt-4 font-display text-xl font-semibold tracking-tight text-ink-soft" data-id="element-232" data-mp="25otj8ey9ravq">Admin</h1>

        <form className="mt-8 rounded-card border border-line bg-white p-6 md:p-8" onSubmit={async event => {
        event.preventDefault();
        if (loading) return;
        setLoading(true);
        const result = await login(email, password);
        if (!result.ok) {
          setError(result.error ?? 'Der opstod en fejl. Prøv igen.');
          setErrorCode(result.code ?? '');
          setPassword('');
          setLoading(false);
          return;
        }
        setError('');
        setErrorCode('');
        navigate('/admin');
      }} data-id="element-233" data-mp="2anencpgn6epg">
          <TextField id="admin-mail" label="E-mail" type="email" required autoComplete="off" value={email} onChange={event => {
          setEmail(event.target.value);
          if (error) {
            setError('');
            setErrorCode('');
          }
        }} data-id="element-234" data-mp="z76n4uoonfgy" />
          <TextField id="admin-kode" label="Password" type="password" required autoComplete="current-password" className="mt-5" value={password} onChange={event => {
          setPassword(event.target.value);
          if (error) {
            setError('');
            setErrorCode('');
          }
        }} data-id="element-235" data-mp="vzjuknpkzmym" />

          {error && <div role="alert" className="mt-4 rounded-xl bg-danger/10 px-4 py-3 text-sm text-danger" data-id="element-236" data-mp="1tm0nlgra7eek">
              <p className="flex items-start gap-2" data-id="element-237" data-mp="1omo1iy88ibd1">
                <AlertCircleIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-238" data-mp="36l2h7oadnmq1" />
                {error}
              </p>
              {errorCode && <p className="mt-1.5 pl-6 font-mono text-xs text-danger/80" data-id="element-239" data-mp="3bhswwai9sgax">{errorCode}</p>}
            </div>}

          <Button type="submit" size="lg" className="mt-7 w-full" disabled={loading || authLoading} data-id="element-240" data-mp="32ixocrrr6u4g">
            {loading ? <>
                <Loader2Icon className="h-5 w-5 animate-spin" aria-hidden="true" data-id="element-241" data-mp="3q9bkatdgld4b" />
                Logger ind …
              </> : 'Log ind'}
          </Button>
        </form>

        <p className="mt-6 text-center text-sm text-ink-muted" data-id="element-242" data-mp="3ggw4a1lq2ym2">
          <Link to="/" className="transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-243" data-mp="3lh1qh2983swr">
            Tilbage til hjemmesiden
          </Link>
        </p>
      </motion.div>
    </div>;
}